import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { decrypt } from "components/encryptDecrpt";
import { IUser } from "atom/user";

const PrivateRoutes: React.FC = () => {
    const data = localStorage.getItem('pulseUserInfo')?.replaceAll('"', '')
    if (data && decrypt(data)) {
        const user = data && (JSON.parse(decrypt(data))) as IUser
        return user && user?.id > 0 ? <Outlet /> : <Navigate to="/login" replace />;
    }
    else {
        return <Navigate to="/login" replace />;
    }
};

export default PrivateRoutes;